import { clone } from "../../core/index.js";
/**
 * For each class set the owner specification.
 */
export function addDataSpecification(structure, specifications) {
    const schemaToSpecification = buildSchemaToSpecificationMap(specifications);
    const result = clone(structure);
    const classes = result.getClasses();
    result.specification = schemaToSpecification[structure.psmIri] ?? null;
    for (const structureClass of classes) {
        structureClass.specification = schemaToSpecification[structureClass.structureSchema] ?? null;
    }
    return result;
}
function buildSchemaToSpecificationMap(specifications) {
    const result = {};
    for (const specification of specifications) {
        for (const iri of specification.psms) {
            result[iri] = specification.iri;
        }
    }
    return result;
}
//# sourceMappingURL=add-data-specification.js.map